import {
  FormContainer,
  FormInputsContainer,
} from "@/template/components/Form/styles";
import styled, { css } from "styled-components";

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;

  svg {
    font-size: 3rem;
    color: ${({ theme }) => theme.colors.primary[500]};
  }

  ${({ theme }) => theme.breakpoints.md.query} {
    svg {
      font-size: 2.5rem;
    }
  }
`;

interface HexToRgbaParams {
  hex: string;
  alpha: number;
}

const hexToRgba = (
  hex: HexToRgbaParams["hex"],
  alpha: HexToRgbaParams["alpha"]
): string => {
  const r: number = parseInt(hex.slice(1, 3), 16);
  const g: number = parseInt(hex.slice(3, 5), 16);
  const b: number = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: ${({ theme }) => hexToRgba(theme.colors.default[950], 0.8)};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  ${({ theme }) => theme.breakpoints.md.query} {
    align-items: flex-start;
    padding: 1rem;
  }
`;

export const ModalBox = styled.div<{ $isModal: boolean }>`
  background: ${({ theme }) => theme.colors.default[50]};
  padding: 3rem;
  border-radius: 12px;
  width: 100%;
  box-shadow: 0 0 10px
    ${({ theme }) => hexToRgba(theme.colors.default[950], 0.2)};
  position: relative;
  max-width: 1295px;
  flex-shrink: 0;
  overflow-y: visible;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 48px;
  ${({ $isModal }) =>
    $isModal &&
    css`
      ${FormContainer} {
        background: #fff;
        padding: 24px;
      }

      ${FormInputsContainer} {
        ${({ theme }) => theme.breakpoints.sm.query} {
          display: grid;
        }
      }
    `}

  ${({ theme }) => theme.breakpoints.md.query} {
    max-width: 400px;
    gap: 0;
  }

  ${({ theme }) => theme.breakpoints.lg.query} {
    max-width: 1365px;
    padding: 1rem;
  }

  ${({ theme }) => theme.breakpoints.xs.query} {
    padding: 1.5rem;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0rem;
  right: 1.5rem;
  background: transparent;
  color: ${({ theme }) => theme.colors.primary[500]};
  border: none;
  font-size: 3rem;
  cursor: pointer;

  ${({ theme }) => theme.breakpoints.md.query} {
    font-size: 2rem;
    right: 0.5rem;
  }
`;

export const ModalHeader = styled.div`
  text-align: center;
  font-weight: 550;
`;

export const Title = styled.h2`
  font-size: 39px;
  margin-bottom: 0.5rem;

  ${({ theme }) => theme.breakpoints.md.query} {
    font-size: 30px;
  }
`;

export const Subtitle = styled.p`
  font-size: 17px;

  ${({ theme }) => theme.breakpoints.md.query} {
    font-size: 14px;
    margin-bottom: 2rem;
  }
`;

export const ModalFormContainer = styled.div`
  width: 100%;
  max-width: 550px;
  margin: 0 auto;
  box-sizing: border-box;
  flex: 1;
  overflow-y: auto;
`;

export const ThankYouContainer = styled.div`
  width: 100%;
  max-width: 550px;
  margin: 0 auto;
  box-sizing: border-box;
  height: 800px;
  align-content: center;
  text-align: center;
`;
